import React, { useState } from 'react'
import useFormSubmission from './useFormSubmission'
import { FormInput } from './FormFields'
import Confetti from 'react-confetti'
import Link from 'components/Link'
import { FormField } from './index'

interface QuickContactFormProps {
    formUrl?: string
    formFields?: Array<FormField>
    confirmationTitle?: {
        title: string
        subtitle: string
        description: string
    }
    confirmationMessageCTA?: {
        title: string
        url: string
    }
    onSubmitSuccess?: () => void
    cta?: {
        label: string
    }
}

export default function QuickContactForm({
    formUrl,
    cta,
    formFields,
    confirmationTitle,
    confirmationMessageCTA,
    onSubmitSuccess,
}: QuickContactFormProps) {
    const [submitted, setSubmitted] = useState(false)
    const [confetti, setConfetti] = useState(false)
    const formFieldsToRender = formFields?.filter((field) => field.enable !== false)

    const { handleSubmit, values, handleChange, setFieldValue, errors, touched, handleBlur } = useFormSubmission({
        formUrl,
        formFields: formFieldsToRender,
        onSubmitSuccess: () => {
            setSubmitted(true)
            setConfetti(true)
            setTimeout(() => {
                onSubmitSuccess?.()
            }, 3000)
        },
    })

    if (submitted) {
        return (
            <>
                {confetti && (
                    <div className="fixed inset-0">
                        <Confetti onConfettiComplete={() => setConfetti(false)} recycle={false} numberOfPieces={500} />
                    </div>
                )}
                <div className="mt-4 rounded-md bg-[#1B3154] px-6 py-8">
                    <h4 className="text-white">
                        ✅ <strong>{confirmationTitle?.title}</strong>
                    </h4>
                    <p className="text-white/80">{confirmationTitle?.subtitle}</p>
                    <p className="mb-0 text-white/80">{confirmationTitle?.description}</p>
                </div>
            </>
        )
    }

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid gap-4">
                {formFieldsToRender?.map((field) => (
                    <div key={field.name} className="space-y-1">
                        <FormInput
                            name={field.name}
                            placeholder={field.placeholder}
                            type={field.type || 'text'}
                            value={values[field.name]}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched[field.name] ? errors[field.name] : undefined}
                            component={field.component}
                            hubspotField={field.hubspotField}
                            options={field.options}
                            optional={field.optional}
                        />
                    </div>
                ))}
            </div>

            <button
                type="submit"
                className="w-full rounded-lg bg-[#4BB3FD] px-4 py-2 text-white transition-colors hover:bg-[#4BB3FD]/90"
            >
                {cta?.label || 'Submit'}
            </button>
        </form>
    )
}
